<template>
  <div class="profiles">

    <div class="profile_add form-group">
      <span
        class="mdi mdi-plus-circle-outline btn btn-success btn-fill"
        @click.prevent="pred_new_profile"
      >{{ translate('notification.profile.to_add') }}</span>
    </div>

    <div class="notification_list">
      <div class="header" v-if="this.$store.getters.getPermissions.permissionGod === true">
        <p>
          {{translate('notification.notification_my')}}
        </p>
      </div>
      <NotificationItem
        v-for="(notice,key) in notification_list_my"
        :key="key"
        :notice = "notice"
        :channels_list = "channels_list"
        :triggers_list = "triggers_list"
        class="notice-item"
        @reload="reload"
      />
    </div>

    <div class="notification_list" v-if="this.$store.getters.getPermissions.permissionGod === true">
      <div class="header">
        <p>
          {{translate('notification.notification_all')}}
        </p>
      </div>
      <NotificationItem
        v-for="(notice, key) in notification_list_all"
        :key="key"
        :notice = "notice"
        :channels_list = "channels_list"
        :triggers_list = "triggers_list"
        class="notice-item"
        @reload="reload"
      />
    </div>
  </div>
</template>

<script>

import NotificationItem from "./Notification/NotificationItem";
import NotificationEdit from "./Notification/NotificationEdit";
import GlobalConfirm from "components/UIComponents/Confirm/GlobalConfirm.vue";

export default {
  name: 'notification',
  components: { NotificationItem },
  data () {
    return {
      notification_list_all: [],
      notification_list_my: [],
      channels_list: [],
      triggers_list: []
    }
  },
  mounted () {
    this.get_list()
  },
  activated () {
    this.get_list()
  },
  methods: {
    pred_new_profile(){
      this.$http.v1.getNotificationChannelsList((response) => {
        if (response.data.my.length === 0){
          let t = this.$createElement(GlobalConfirm, {
            props: {
              text: this.translate('notification.text_not_channel')
            },
            on: {
              close: () => {
                this.$modal.hide('pred_new_profile')
              },
              confirm: () => {
                this.$router.push({ path: '/notification/settings' })
                this.$modal.hide('pred_new_profile')
              }
            }
          })
          let temp = {
            render () { return t }
          }
          this.$modal.show(temp, {}, {height: 'auto',  width: 800, adaptive: true, clickToClose: true, scrollable: true, name: 'pred_new_profile'})

        }else{
          this.new_notification()
        }
      })
    },
    new_notification(){
      var t = this.$createElement(NotificationEdit, {
        props: {}, on: {
          close: () => {this.$modal.hide('dynamic-modal') },
          reload: () => {this.get_list()}
        }
      })
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto',  width: 800, adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})
    },
    get_list(){
      this.$http.v1.getListNotification((response) => {
        //my norifications
        this.notification_list_my = response.data.notification.my
        for (let notice in this.notification_list_my) {
          this.notification_list_my[notice].id = +notice
          for (let index in this.notification_list_my[notice].devices) {
            this.notification_list_my[notice].devices[index] = {
              name: '(' + this.notification_list_my[notice].devices[index].fid + ') ' + '<b>' + this.notification_list_my[notice].devices[index].name2 + '</b>',
              id: this.notification_list_my[notice].devices[index].device_id,
              role: 'children',
              group_id: +this.notification_list_my[notice].devices[index].group_id,
              checked: true,
              fid: this.notification_list_my[notice].devices[index].fid
            }
          }

          for (let index in this.notification_list_my[notice].groups) {
            this.notification_list_my[notice].groups[index] = {
              id: +this.notification_list_my[notice].groups[index].id,
              expanded: false,
              hasExpanded: true,
              parent: this.notification_list_my[notice].groups[index].parent,
              name: this.notification_list_my[notice].groups[index].name,
              children: [],
              role: 'group',
              checked: true
            }
          }
        }
        // all norifications for god
        this.notification_list_all = response.data.notification.all
        for (let notice in this.notification_list_all) {
          this.notification_list_all[notice].id = +notice
          for (let index in this.notification_list_all[notice].devices) {
            this.notification_list_all[notice].devices[index] = {
              name: '(' + this.notification_list_all[notice].devices[index].fid + ') ' + '<b>' + this.notification_list_all[notice].devices[index].name2 + '</b>',
              id: this.notification_list_all[notice].devices[index].device_id,
              role: 'children',
              group_id: +this.notification_list_all[notice].devices[index].group_id,
              checked: true,
              fid: this.notification_list_all[notice].devices[index].fid
            }
          }

          for (let index in this.notification_list_all[notice].groups) {
            this.notification_list_all[notice].groups[index] = {
              id: +this.notification_list_all[notice].groups[index].id,
              expanded: false,
              hasExpanded: true,
              parent: this.notification_list_all[notice].groups[index].parent,
              name: this.notification_list_all[notice].groups[index].name,
              children: [],
              role: 'group',
              checked: true
            }
          }
        }
        // other data
        this.channels_list = response.data.channels
        this.triggers_list = response.data.triggers_definition

      })
    },
    reload(){
      this.get_list()
    }

  }
}

</script>
<style lang='scss'>

  .profiles{
    padding: 10px;
  }
  .notification_list{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    .header{
      display: inline-block;
      width: 100%;
      p{
        margin-bottom: 0;
      }
    }
    .notice-item{
      width: 25%;
      padding: 10px;
    }
  }


  @media (max-width: 1400px) {
    .notification_list{
      .notice-item{
        width: 33%;
      }
    }
  }

  @media (max-width: 1100px) {
    .notification_list{
      .notice-item{
        width: 50%;
      }
    }
  }

  @media (max-width: 600px) {
    .profile_add{
      span{
        width: 100%;
      }
    }
    .notification_list{
      .notice-item{
        width: 100%;
      }
    }
  }
</style>
